// Polyfill for IE11
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
(function () {
  if (typeof window.CustomEvent === "function") return false;

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(
      event,
      params.bubbles,
      params.cancelable,
      params.detail
    );
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

// TODO: Remove Legacy Analytics
const triggerSponsorshipAnalyticsEvent = (
  eventName = "customEvent.wvus",
  eventData = {}
) => {
  const event = new CustomEvent(eventName, eventData);
  event.eventData = eventData;
  document.dispatchEvent(event);
};

const triggerAnalyticsEvent = (
  eventName = "customEvent.wvus",
  eventData = {}
) => {
  const event = new CustomEvent(eventName, {
    detail: eventData
  });
  document.dispatchEvent(event);
};

export { triggerSponsorshipAnalyticsEvent, triggerAnalyticsEvent };
